import React, { Fragment, RefObject } from 'react'

import Icon from '../Icon'

import styles from './FormCheckbox.module.scss'
import globalStyles from '../../styles/global.module.scss'

interface FormCheckboxPropsInterface {
  name: string
  elementRef: RefObject<HTMLInputElement>

  handleChange?: any
  checked?: boolean
  disabled?: boolean
}

export default ({
  name,
  elementRef,
  checked,
  disabled,
  handleChange,
  ...rest
}: FormCheckboxPropsInterface) => (
  <Fragment>
    <input
      {...rest}
      ref={elementRef}
      className={`${globalStyles['shadow-input']} ${styles['input']}`}
      type="checkbox"
      id={name}
      name={name}
      onChange={handleChange}
      checked={checked}
      disabled={disabled}
    />

    <label className={styles['label']} htmlFor={name}>
      <span className={styles['icon']}>
        <Icon name="success" data-element="checkbox-icon" />
      </span>
    </label>
  </Fragment>
)
